<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="OT" id="toc_marker-4"><a href="#/Healy_Hauerwas5#toc3">Acknowledgments</a></p>
<p class="BODYFLUSH">The book has been long in the writing, interrupted as it was by various excursions into academic administration. These were interesting enough to delay what I should have realized was my inevitable “retreat to the faculty,” as a former dean of University of San Diego, Pat Drinan, used to call the move from administration to faculty status. Accordingly, I owe Linda Bieze at Eerdmans and the editors of this series many thanks for their patience as they waited some years beyond the original deadline for this book.</p>
<p class="BODY">I have had the benefit of trying out a few of the broader ideas here in various gatherings over the years: the Karl Barth Society of North America; a number of meetings of ethnographers and others interested in the empirical church organized by Pete Ward, Gerard Mannion, and Paul Murray; the critically friendly atmosphere of the Catholic Theological Association of Great Britain. Among those who helped me, whether by reading something of mine or by other forms of encouragement, I am especially grateful to Kathryn Tanner, John Webster, Karen Kilby, Paul Murray, David Haddorff, and Paul Molnar, which is not at all to say that any of them would agree with what I have written here. I also thank my dean, Jeff Fagen. Jeff’s decanal skills have made the College of Arts and Sciences at St. John’s University a place where scholarship is strongly encouraged and supported.</p>
<p class="BODY-T2">I dedicate the book to David Kelsey. I was lucky enough to TA for David for a year while working toward my doctorate. I learned a lot from him then — though I now kick myself for not learning more — and I have continued to learn in the intervening years through his magnificent work, as will be evident in this book. He and I have not discussed this book, nor have we spoken about Stanley Hauerwas, so I have no sense of what he would think of it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Healy_Hauerwas-6.vue?0347862d